<template>
  <div
    ref="headerRef" class="relative top-0 z-200 mx-auto max-w-full w-full flex-center transition-all"
    :style="`--transparent_title_color: ${headerSettings?.transparent_title_color};`" :class="stickyAlways"
  >
    <header
      v-if="headerSettings"
      id="nova-header" ref="headerRef" :class="[sticky_header_type, lastYPosition <= height ? 'on-top' : '']"
      :style="headerStyleWithPadding"
      class="group top-0 z-999 max-w-full w-full color-headerColor transition-all-350 md:mb-0"
    >
      <div class="bg sps-group-hover:bg-headerBgColor! absolute left-0 top-0 z--1 h-0 w-full bg-headerBgColor transition-all transition-all-500 sps-group-hover:h-full" />
      <div
        v-if="!isMob" id="shopify-section-header"
        :class="`${(headerSettings?.full_width ?? true) ? 'w-full max-w-full' : 'page'}`"
        class="header-color grid m-a gap-4 grid-items-center px-40px py-20px" :style="headerStyles"
      >
        <!-- 搜索 -->
        <div class="w-auto" style="grid-area: tools">
          <BlocksHeadersComponentsSearch :datas="datas" />
        </div>
        <!-- logo -->
        <BlocksHeadersComponentsLogo :datas style="grid-area: logo" :image="headerSettings?.pc_image" />
        <!-- 右侧组件框 -->
        <div class="notranslate flex items-center justify-end gap-4" style="grid-area: buttons">
          <!-- 语言、国家、货币 -->
          <div
            v-if="headerSettings?.currency || headerSettings?.Language"
            class="flex cursor-pointer items-baseline gap-4"
          >
            <!-- 语言 -->
            <n-select
              v-if="headerSettings?.Language && languageOptions.length > 1" v-model:value="language" :to="false"
              :theme-overrides="themeOverrides" class="notranslate min-w-110px"
              :options="languageOptions"
            />
            <!-- 货币 -->
            <n-select
              v-if="headerSettings?.currency && currencyOptions.length > 1" v-model:value="currency_code"
              :to="false" :theme-overrides="themeOverrides" class="notranslate min-w-110px"
              :render-label="renderLabelcurrencyOptions" :options="currencyOptions"
              @update:value="handleSelectFinance"
            />
          </div>

          <!-- 个人中心 -->
          <n-dropdown trigger="hover" :options="personnelOptions" @select="personnelHandleSelect">
            <icon v-if="headerSettings?.self_content" name="icon:peoper" class="header-color h-20px w-20px cursor-pointer" />
          </n-dropdown>
          <!-- 购物车 -->
          <BlocksHeadersComponentsBag :datas="datas" :count="count" class="header-color" />
        </div>
        <!-- 导航菜单 -->
        <div v-if="headerSettings?.pc_menu" style="grid-area: menu" :class="headerStyle == 2 ? 'm-auto' : ''">
          <n-menu
            :dropdown-props="{
              to: false,
            }" :options="menuOptions_PC" mode="horizontal"
          />
        </div>
      </div>
      <!-- 移动端页头 -->
      <BlocksHeadersComponentsMob v-else :datas :menu-options_-mob :menu-options :count />
      <Cart v-model:car-show="showCart" />
    </header>
  </div>
</template>

<script setup lang="tsx">
import type { RouteLocationRaw } from '#vue-router'
import type { DropdownOption, SelectGroupOption, SelectOption, SelectProps } from 'naive-ui'
import type { VNodeChild } from 'vue'
import { getShopCarcount, loginOut } from '@/services/api/index'
import { convertData } from '~/utils/common/convert-data'
import { elementStyle } from '~/utils/common/elementStyle'
import useScroll from './utils/scroll'

defineOptions({
  name: 'HeadersSection',
})
const props = defineProps<{
  datas?: any
}>()
const { height } = useElementBounding(useTemplateRef('headerRef'))
const isMob = useIsMobile()
const { showCart } = storeToRefs(useShopCart())
const { languageList } = storeToRefs(useThemeEditorStore())
const { ukey, PHPSESSID, currency_code, language, finance } = storeToRefs(useUserInfo())
const { t } = useI18n()
const router = useRouter()
const headerData = computed(() => props.datas?.settings?.header)
const headerSettings = computed(() => props.datas?.settings?.header?.settings)
const headerStyle = computed(() => headerData.value?.settings?.nav as 1 | 2 | 3 | 4)
const themeOverrides: NonNullable<SelectProps['themeOverrides']> = {
  peers: {
    InternalSelection: {
      border: 'none',
      borderActive: 'none',
      borderHover: 'none',
      borderFocus: 'none',
      boxShadowActive: 'none',
      boxShadowFocus: 'none',
      color: 'transparent',
      colorActive: 'transparent',
    },

  },
}
/**  页头布局样式 */
const headerStyles = computed(() => {
  if (headerStyle.value == 1) {
    return `grid-template: "logo menu tools buttons" auto / auto 1fr auto auto;`
  }
  return `grid-template: "tools logo buttons" auto "menu menu menu" auto / 1fr auto 1fr;`
})

// 页头样式（包含 padding）
const headerStyleWithPadding = computed(() => {
  const baseStyle = elementStyle(headerSettings.value)
  const separatorStyle = (headerSettings.value?.show_line_separator ?? true)
    ? `1px solid ${headerSettings.value?.line_separator_color ?? 'rgb(221, 221, 221)'}`
    : ''

  return Object.assign({}, baseStyle, {
    borderBottom: separatorStyle || undefined,
  })
})

function uniqueArrayByProperty(arr: [], key: string) {
  const seen = new Map()
  return arr.filter((item) => {
    const k = item[key]
    if (seen.has(k))
      return false
    seen.set(k, true)
    return true
  })
}

/** * 国家语言 */
const languageOptions = computed(() => {
  if (languageList.value?.langs) {
    const langs = uniqueArrayByProperty(languageList.value?.langs as [], 'code')
    return langs
      ?.filter((i: any) => i.code)
      .map((i: any) => {
        i.key = i.title
        return { value: i.code, label: i.name, ...i }
      })
  }
  return []
})

// /** * 显示激活国家 */
// const activeLanguage = computed(() => {
//   const lang = head_data.value?.slangs?.find((i: any) => i.code == locale.value)
//   if (lang) {
//     return lang
//   }
//   return {
//     name: head_data.value?.langs,
//   }
// })

/** * 获取货币 */
const currencyOptions = computed(() => {
  if (languageList.value?.currency) {
    return languageList.value?.currency?.map((i: any) => {
      i.key = i.title
      return { value: i.code, label: i.name, ...i }
    })
  }
  return []
})

const menuOptions = computed(() => {
  return [
    {
      label: t('headers.currency'),
      key: '1',
      show: headerData.value?.settings?.currency,
      children: languageList.value?.currency?.map((i: any) => {
        return { label: i.name, key: i.code, type: 'currency' }
      }),
    },
    {
      label: t('headers.language'),
      key: '2',
      show: headerData.value?.settings?.Language,
      children: languageList.value?.langs?.filter((i: any) => i.code).map((i: any) => {
        i.key = i.title
        return { key: i.code, label: i.name, type: 'langs' }
      }),
    },
  ]
})

function convertLanguageCode(code: string) {
  // 检查输入的代码是否包含连字符 '-'
  if (code.includes('-')) {
    // 提取连字符后的部分，并转换为小写
    return code.split('-')?.pop()?.toLowerCase()
  }
  else {
    // 如果输入的代码是 'en' 或其他没有连字符的代码，直接返回
    return code
  }
}
/**  移动端菜单 */
const active = ref(false)

/**  语言列表自定义渲染函数 */
const renderLabelcurrencyOptions = (option: SelectOption | SelectGroupOption): VNodeChild => {
  return (
    <div class="flex-center gap-2">
      <sps-img
        class="w-20px"
        width="20"
        fit="contain"
        src={`http://imgs.shopssea.com/public/image/countrys/${convertLanguageCode(option.gcode as string)}.svg`}
      />
      <span>{option.label}</span>
    </div>
  )
}

/**  选择语言货币 */
const handleSelectFinance = (key: string, option: DropdownOption) => {
  finance.value = option.finance as string
}

/** PC 菜单数据转换 */
const menuOptions_PC = computed(() => {
  if (headerData.value?.pc_menu_content?.id) {
    return convertData(headerData.value.pc_menu_content.son)
  }
  return []
})

/** Mobile 菜单数据转换 */
const menuOptions_Mob = computed(() => {
  if (headerData.value?.mob_menu_content?.id) {
    return convertData(headerData.value.mob_menu_content.son)
  }
  return []
})

/**  个人中心下拉菜单 */
const personnelOptions = computed(() => {
  return !ukey.value
    ? [
        {
          label: t('headers.login'),
          key: '/account/login',
        },
        // {
        //   label: t('headers.register'),
        //   key: '/account/register',
        // },
      ]
    : [
        {
          label: t('headers.orders'),
          key: '/account/orders',
        },
        {
          label: t('headers.address'),
          key: '/account/address',
        },
        {
          label: t('headers.logout'),
          key: 'logout',
        },
      ]
})

/** 个人中心菜单点击事件处理  */
const personnelHandleSelect = async (key: RouteLocationRaw) => {
  if (key == 'logout') {
    await logout()
    return
  }
  router.push(key)
}

/**  退出登录 */
const logout = async () => {
  await loginOut()
  ukey.value = null
  PHPSESSID.value = null
  active.value = false
  router.push('/')
}

const { count } = storeToRefs(useShopCart())

const headerRef = ref<HTMLElement | null>(null)
/**  页头固定方式 */
const { sticky_header_type, stickyAlways, lastYPosition } = useScroll(props, headerRef)

/**  获取购物车数量 */
const { refresh } = await useAsyncData('useShopCart', getShopCarcount, {
  default: () => 0,
  lazy: true,
  server: false,
  transform({ data }) {
    count.value = data?.count as number
    return data?.count
  },
})

/**  注入数据 方便组件传值 */
const nuxtApp = useNuxtApp()
if (typeof nuxtApp.$addCart != 'function') {
  nuxtApp.provide('addCart', refresh)
}
</script>

<style scoped lang="scss">
  :deep(.n-menu) {
  flex-wrap: wrap;
}

:deep(.n-dropdown-menu-wrapper > .n-dropdown-menu) {
  max-height: 300px;
  overflow-y: scroll;
}

// 输入框
:deep(.n-input) {
  background-color: var(--search-bg-color) !important;
  color: var(--search-color) !important;
}

:deep(.n-input .n-input__input-el) {
  color: var(--search-color) !important;
}

:deep(.n-base-icon.n-menu-item-content__arrow) {
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.n-menu-item-content-header) {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#nova-header:has(.n-menu-item-content--hover) {
  background-color: var(--header-bg-color) !important;
}

.header-hidden:has(.is-transparent) {
  // transform: translateY(-200%);
  .bg {
    height: 0%;
  }
}

.on-scroll-up.on-top:not(.is-transparent) {
  .bg {
    height: 100%;
  }
}

.is-transparent {
  position: absolute;
  background-color: transparent;
  color: var(--transparent_title_color);
}

.is-sticky:has(.is-transparent-active) #nova-header {
  .bg {
    height: 100%;
  }
  // background-color: var(--header-bg-color) !important;
}

.is-sticky {
  position: sticky;
  top: 0;
  .bg {
    height: 100%;
  }
}

.is-sticky-active.is-sticky-active.is-transparent-active.is-transparent.on-scroll-up {
  background-color: transparent;
  .bg {
    height: 0%;
  }
}

.is-transparent-active:has(.is-transparent) {
  background-color: transparent;
  .bg {
    height: 0%;
  }
}

.is-transparent-active .is-transparent {
  position: absolute;
  top: 0;
  background-color: transparent;
  .bg {
    height: 0%;
  }
}

.always-sticky {
  position: sticky;
  top: 0;
}

.not-sticky {
  position: relative;
  top: 0;
  .bg {
    height: 100%;
  }
}

.not-sticky.is-transparent {
  position: absolute;
  top: 0;
  background-color: transparent;
  .bg {
    height: 0%;
  }
}

:deep(#nova-header) {
  .header-color {
    color: var(--color-headerColor) !important;
  }

  &.is-transparent-active.is-transparent,
  &:not(.is-transparent).on-scroll-up,
  &:not(.is-transparent).is-sticky,
  &:not(.is-transparent).not-sticky,
  &.is-sticky-active.is-transparent-active {
    color: var(--color-headerColor);

    .header-color {
      color: var(--color-headerColor) !important;

      .n-base-selection-input__content {
        color: var(--color-headerColor) !important;
      }

      .n-base-icon > svg {
        color: var(--color-headerColor) !important;
      }
    }

    .n-menu.n-menu--horizontal .n-menu-item-content .n-menu-item-content-header a {
      color: var(--color-headerColor) !important;
    }
  }

  &.is-transparent {
    color: var(--transparent_title_color);

    .header-color {
      color: var(--transparent_title_color) !important;

      .n-base-icon > svg {
        color: var(--transparent_title_color) !important;
      }

      .n-base-selection-input__content {
        color: var(--transparent_title_color) !important;
      }
    }
    @media (hover: hover) and (pointer: fine) {
      &:hover {
        color: var(--color-headerColor);
        .bg {
          height: 100%;
        }
        .header-color {
          color: var(--color-headerColor) !important;

          .n-base-selection-input__content {
            color: var(--color-headerColor) !important;
          }

          .n-base-icon > svg {
            color: var(--color-headerColor) !important;
          }
        }
      }
    }
  }

  &:hover .n-menu.n-menu--horizontal .n-menu-item-content .n-menu-item-content-header a {
    color: var(--color-headerColor) !important;
  }

  .n-menu.n-menu--horizontal .n-menu-item-content .n-menu-item-content-header a {
    color: var(--transparent_title_color);
  }

  .n-menu.n-menu--horizontal .n-menu-item-content .n-menu-item-content-header {
    color: var(--transparent_title_color);
  }

  &:has(.n-menu-item-content--hover) {
    .header-color,
    a {
      color: var(--color-headerColor) !important;
    }
  }
}
</style>
